import React, { FC } from "react";
import { Sheet as OrginalSheet } from "zmp-ui";

export const Sheet = (props) => {
  return <OrginalSheet {...props} />;
};

export const ActionSheet = (props) => {
  return <OrginalSheet.Actions {...props} />;
};
